(() => {
  const init = () => {
    const nav = document.querySelector('body.blurams-template #MainContent .navbar');
    if (!nav || nav.querySelector('.blurams-menu-toggle')) return;

    const toggle = document.createElement('button');
    toggle.className = 'blurams-menu-toggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-label', 'Open navigation menu');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span aria-hidden="true"></span>';

    const menu = document.createElement('div');
    menu.className = 'blurams-mobile-menu';
    menu.setAttribute('aria-label', 'Mobile navigation');
    const desktopLinks = nav.querySelectorAll('.blurams-site-links > a');
    desktopLinks.forEach((link) => {
      const mobileLink = document.createElement('a');
      mobileLink.href = link.href;
      mobileLink.textContent = link.textContent;
      menu.append(mobileLink);
    });

    const close = () => {
      nav.classList.remove('is-mobile-menu-open');
      document.body.classList.remove('blurams-menu-lock');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
    };
    const open = () => {
      nav.classList.add('is-mobile-menu-open');
      document.body.classList.add('blurams-menu-lock');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close navigation menu');
    };

    toggle.addEventListener('click', () => nav.classList.contains('is-mobile-menu-open') ? close() : open());
    menu.addEventListener('click', (event) => { if (event.target.closest('a')) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    window.addEventListener('resize', () => { if (window.innerWidth > 900) close(); }, { passive: true });
    nav.append(toggle, menu);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
